import React from 'react';
var DndTableDragContext = /*#__PURE__*/React.createContext({});
export { DndTableDragContext };